import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const storyGenrater = (payload) => {
  return Api(endPoints.storyGenrater, payload, requestType.POST);
};

const storyDelete = (id) => {
  return Api(`${endPoints.storyDelete}/${id}`, {}, requestType.DELETE);
};

export { storyGenrater, storyDelete };
